export default __webpack_public_path__ + "static/media/0.11233f38.png";